__webpack_require__.p = "https://oss-assets.amberstudent.cn/amber-user-website/VP1-8.52.15-a611-amber-user-website-prod-hk-1829/assets/";